import {Font, StyleSheet} from '@react-pdf/renderer';
import {COLORS} from './constants';

Font.register({
  family: 'IRANYekanXFaNum',
  fonts: [
    {src: '/fonts/IRANYekanXFaNum-Regular.ttf', fontWeight: 400},
    {src: '/fonts/IRANYekanXFaNum-Medium.ttf', fontWeight: 500},
    {src: '/fonts/IRANYekanXFaNum-SemiBold.ttf', fontWeight: 600},
    {src: '/fonts/IRANYekanXFaNum-Bold.ttf', fontWeight: 700},
  ],
});

Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
  page: {
    backgroundColor: COLORS.white,
    fontFamily: 'IRANYekanXFaNum',
    fontSize: 9,
    color: COLORS.textPrimary,
    direction: 'rtl',
    paddingBottom: 40,
  },

  pageTitle: {
    textAlign: 'center',
    fontSize: 15,
    fontWeight: 700,
    color: COLORS.greenDark,
    marginTop: 18,
    marginBottom: 16,
  },

  card: {
    margin: 24,
    // marginBottom: 16,
    backgroundColor: COLORS.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border,
    padding: 16,
  },

  section: {
    marginHorizontal: 24,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.border,
  },

  sectionCard: {
    margin: 12,
    backgroundColor: COLORS.cardBg,
    borderRadius: 8,
    padding: 16,
  },

  icon: {
    height: 16,
  },

  //#region header
  header: {
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: COLORS.bgHeader,
    paddingVertical: 14,
    paddingHorizontal: 24,
    marginBottom: 10,
  },
  headerRight: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  logoImg: {
    width: 90,
    height: 24,
  },
  headerLeft: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 330,
  },
  headerInfoBlock: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    marginLeft: 16,
  },
  headerInfoText: {
    fontSize: 12,
    color: COLORS.textSecondary,
    marginRight: 4,
  },

  //#endregion

  //#region Risk summary card
  riskSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  riskGradeBlock: {
    alignItems: 'center',
    marginLeft: 20,
  },
  pointer: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    top: 11,
    // left: 179,
  },
  riskGradeTitle: {
    fontSize: 14,
    fontWeight: 700,
  },
  riskGradeLabel: {
    fontSize: 11,
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 5,
    width: 80,
  },
  riskScaleRow: {
    flexDirection: 'row-reverse',
    marginTop: 60,
    marginBottom: 6,
  },
  riskScaleBadge: {
    marginLeft: 2,
    fontSize: 8,
    fontWeight: 400,
    paddingTop: 1,
    width: 13,
    color: COLORS.textPrimary,
    textAlign: 'center',
  },
  riskScaleBadgeActive: {},
  riskNoteRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  riskNoteText: {
    fontSize: 10,
    color: COLORS.textSecondary,
  },

  gaugeBlock: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gaugeImg: {
    width: 170,
    height: 110,
  },

  gaugeInner: {
    width: 180,
    height: 140,
    position: 'relative',
  },
  scoreBoard: {
    width: '100%',
    height: '100%',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleIndicatorCentered: {
    width: 60,
    height: 60,
  },
  scoreTextContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  scoreText: {
    fontSize: 10,
    fontWeight: '500',
    color: '#333',
  },

  summaryDivider: {
    borderTopWidth: 1,
    borderTopColor: COLORS.border,
    marginTop: 14,
    marginBottom: 10,
  },
  summaryText: {
    direction: 'rtl',
    marginTop: 25,
    marginBottom: 10,
    marginHorizontal: 2,
    fontSize: 11,
    lineHeight: 1.6,
    color: COLORS.textMuted,
    // textAlign: 'right',
  },
  //#endregion

  //#region Score factors details
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginHorizontal: 24,
    marginBottom: 10,
    textAlign: 'right',
  },
  scoreTableWrap: {
    marginHorizontal: 24,
    marginBottom: 20,
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: COLORS.border,
    paddingBottom: 10,
  },
  scoreTableHeaderRow: {
    flexDirection: 'row-reverse',
    paddingVertical: 8,
    paddingHorizontal: 14,
    marginVertical: 5,
  },
  scoreTableHeaderCellTitle: {
    flex: 1,
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'right',
  },
  scoreTableHeaderCellScore: {
    width: 70,
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center',
  },
  scoreRow: {
    flexDirection: 'row-reverse',
    paddingVertical: 4,
    paddingHorizontal: 14,
    alignItems: 'flex-start',
  },
  scoreRowAlt: {
    backgroundColor: COLORS.rowAlt,
  },
  scoreCellTitleWrap: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row-reverse',
    backgroundColor: COLORS.cardBg,
    borderRadius: 5,
    padding: 16,
  },
  scoreCellTitle: {
    fontSize: 12,
    fontWeight: 400,
    marginBottom: 6,
    textAlign: 'right',
    width: 115,
  },
  bulletRow: {
    flexDirection: 'row-reverse',
    fontSize: 10,
    fontWeight: 500,
    opacity: 0.9,
  },
  bulletDot: {
    fontSize: 8,
    marginLeft: 4,
    color: COLORS.textSecondary,
  },
  bulletText: {
    fontSize: 8,
    color: COLORS.textSecondary,
    lineHeight: 1.5,
    flex: 1,
    textAlign: 'right',
  },
  scoreCellScoreWrap: {
    width: 70,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
    height: '100%',
    borderRadius: 8,
    backgroundColor: COLORS.cardBg,
  },
  scoreCellScore: {
    fontSize: 14,
    fontWeight: 500,
    color: COLORS.textPrimary,
  },
  //#endregion

  //#region Cadastre reports
  farmInfoCard: {display: 'flex', flexDirection: 'row-reverse'},
  farmInfoPhoto: {flex: 2, display: 'flex', justifyContent: 'center'},
  farmPhotoFrame: {
    width: '180px',
    height: '180px',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: COLORS.textMuted,
  },
  farmInfoData: {
    flex: 3,
    direction: 'rtl',
    marginTop: 15,
    textAlign: 'right',
    marginRight: 10,
    padding: 20,
    paddingLeft: 0,
    fontSize: 14,
  },
  //#endregion

  //#region coordinate table
  CoordinatesTable: {border: '1px solid #E0E3E5', borderRadius: 16},
  CoordinatesRow: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    height: 49,
    fontSize: 14,
    fontWeight: 500,
  },
  CoordinatesCell: {
    flex: 1,
    height: '100%',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.8,
  },
  //#endregion

  //#region caltivations info
  mainCultivationCardSection: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginVertical: 15,
  },
  mainCultivationPhoto: {marginLeft: 20},
  mainCultivationInfo: {
    display: 'flex',
    flexDirection: 'row-reverse',
    fontSize: 12,
  },
  cultivationAlbumWrapper: {display: 'flex', flexDirection: 'row-reverse'},
  cultivationAlbumItem: {
    width: 80,
    paddingHorizontal: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  //#endregion

  //#region Footer
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: COLORS.bgHeader,
    paddingVertical: 12,
    paddingHorizontal: 24,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  footerItem: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    marginHorizontal: 14,
  },
  footerText: {
    fontSize: 12,
    fontWeight: 400,
    color: COLORS.textSecondary,
    marginRight: 4,
  },
  //#endregion
});

export default styles;
